import * as S from './styles'

const Cabecalho = () => (
  <S.Header>
    <h1>EBAC Jobs</h1>
  </S.Header>
)

export default Cabecalho
